import { currentLanguage } from 'utils/currentLanguage';

export const redirectToTechAssist = (urlSearchQuery) => {
  window.location.href = `/${currentLanguage}/techassist/search${urlSearchQuery}`;
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/redirectToTechAssist.js